export default "__VITE_ASSET__BKtQ7P4v__"